<template>
  <main-layout :selectedMenu="'home'">
    <div class="form addSupplement">
      <h3>
        {{$t('global.填写竞赛投稿信息')}}
        <router-link target="_blank" :to="`/match/${matchDetail.url}`">{{matchDetail.title}}</router-link>
      </h3>
      <input
        type="file"
        class="upInputIMG"
        multiple
        accept="image/*"
        @change="upImg"
      />
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="ruleForm">
        <el-form-item :label="$t('global.投稿作品')">
          <p>
            <router-link
              target="_blank"
              :to="`/video/detail?id=${videoId}`"
            >{{videoDetail.videoTitle}}</router-link>
          </p>
        </el-form-item>
        <el-form-item
          :label="`${$t('global.作品标题')}(${$t('global.英文')})`"
          prop="enTitle"
          v-if="matchDetail.isInternational"
        >
          <el-input v-model="ruleForm.enTitle" :readonly="!isEdit&&videoDetail.videoEnTitle"></el-input>
        </el-form-item>
        <el-form-item
          :label="`${$t('global.作品简介')}(${$t('global.英文')})`"
          prop="enIntroduction"
          v-if="matchDetail.isInternational"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.enIntroduction"
            :readonly="!isEdit&&videoDetail.videoEnIntroduction"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('global.作品图片')" prop="images" required v-if="imageCount">
          <div class="images">
            <span>
              {{$t('global.至少上传')}}
              <b>{{imageCount}}</b>
              {{$t('global.张')}}
            </span>
            <ul>
              <li v-for="(item,index) in ruleForm.images" :key="item" class="imgList">
                <img :src="item | imageUrl('',129,73)" alt />
                <a
                  href="javascript:;"
                  v-if="!canotDelete[item]"
                  @click="deleteImg(index)"
                >{{$t('global.删除')}}</a>
              </li>
              <li>
                <div class="add-wrap" @click="upImgClick">
                  <img src="/static/upload.png" alt class="add" />
                  <span class="font">{{$t('global.请上传图片')}}</span>
                </div>
              </li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item :label="$t('global.参赛类别')" prop="categoryId">
          <el-select
            v-model="ruleForm.categoryId"
            style="width:200px;"
            :placeholder="$t('global.请选择参赛类别')"
          >
            <el-option
              :label="item.title"
              :value="item.categoryId"
              v-for="item in categoryList"
              :key="item.categoryId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('global.参赛方式')" prop="entryMode">
          <el-radio-group v-model="ruleForm.entryMode">
            <el-radio :label="1">{{$t('global.个人')}}</el-radio>
            <el-radio :label="2">{{$t('global.团体')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label prop>
          <a class="rule" href="javascript:;" v-on:click="getRule()">{{$t('global.投稿代表同意参赛条款')}}</a>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">{{$t('global.提交')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </main-layout>
</template>
<script>
import MainLayout from "@/layouts/MainLayout";
import "./css/matchSupplement.css";
export default {
  metaInfo() {
    return {
      title: this.$t("global.填写竞赛投稿信息") + " | MANA"
    };
  },
  components: {
    MainLayout
  },
  data() {
    return {
      videoDetail: {},
      ruleForm: {
        enTitle: "",
        enIntroduction: "",
        images: [],
        categoryId: null,
        entryMode: null
      },
      rules: {
        enTitle: [
          {
            required: true,
            message: `${this.$t("global.请输入作品标题")}(${this.$t(
              "global.英文"
            )})`,
            trigger: "blur"
          }
        ],
        enIntroduction: [
          {
            required: true,
            message: `${this.$t("global.请输入作品简介")}(${this.$t(
              "global.英文"
            )})`,
            trigger: "blur"
          }
        ],
        categoryId: [
          {
            required: true,
            message: this.$t("global.请选择参赛类别"),
            trigger: "blur"
          }
        ],
        entryMode: [
          {
            required: true,
            message: this.$t("global.请选择参赛方式"),
            trigger: "blur"
          }
        ]
      },
      videoId: null,
      matchId: null,
      canotDelete: {},
      matchDetail: {},
      bathImg: "https://image.manamana.net/",
      categoryList: [],
      isEdit: false,
      imageCount: 0
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const { videoId, matchId } = this.$route.params;
      this.videoId = videoId;
      this.matchId = matchId;
      this.getVideo();
      this.getCategory();
      this.getMatch();
    },
    upImgClick() {
      document.querySelector(".upInputIMG").click();
    },
    upImg(e) {
      let param = new FormData();
      let fileNames = [];
      const files = e.target.files;
      [...files].forEach(item => {
        param.append("files", item);
        fileNames.push(item.name);
      });
      param.append("fileNames", fileNames.join());
      // param.append("files", e.target.files);
      this.$http
        .post("/api/common/upload/images", param, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.code === "OK") {
            this.$message({
              message: response.message,
              type: "success"
            });
            for (let i in response.data) {
              this.ruleForm.images.push(this.bathImg + response.data[i].key);
            }
          }
        });
    },
    getVideo() {
      const url = `/api/match/video/getIsEditByVideoId?videoId=${this.videoId}&matchId=${this.matchId}`;
      this.$http.get(url).then(res => {
        this.videoDetail = res.data.domain;
        this.isEdit = res.data.isEdit;
        res.data.domain.videoImages.forEach(
          item => (this.canotDelete[item] = !this.isEdit && true)
        );
        this.ruleForm = {
          enTitle: res.data.domain.videoEnTitle,
          enIntroduction: res.data.domain.videoEnIntroduction,
          images: res.data.domain.videoImages || [],
          categoryId: res.data.domain.categoryId || null,
          entryMode: res.data.domain.entryMode || null
        };
      });
    },

    getRule() {
      this.$http
        .get("/api/common/page", {
          params: {
            title: this.$t("global.参赛条款及细则")
          }
        })
        .then(data => {
          this.$alert(data.data.body, this.$t("global.参赛条款及细则"), {
            dangerouslyUseHTMLString: true
          });
        });
    },
    getMatch() {
      const url = `/api/match/getMatch?matchId=${this.matchId}`;
      this.$http.get(url).then(res => {
        this.matchDetail = res.data;
        this.imageCount = res.data.imageCount || 0;
        this.rules.images = [
          {
            type: "array",
            min: this.imageCount,
            required: true,
            message: `${this.$t("global.至少上传")}${this.imageCount}${this.$t("global.张作品")}`,
            trigger: "blur"
          }
        ];
      });
    },
    getCategory() {
      const url = `/api/match/category/list/match`;
      this.$http.get(url, { params: { matchId: this.matchId } }).then(res => {
        this.categoryList = res.data;
      });
    },
    deleteImg(index) {
      this.ruleForm.images.splice(index, 1);
    },
    goToEdit() {
      this.$router.push(`/UpVideo?edit=true&videoId=${this.videoId}`);
    },
    submitForm() {
      const url = `/api/match/video/updateVideoToMatch`;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$http
            .post(url, {
              ...this.ruleForm,
              images: this.ruleForm.images.join(","),
              matchId: this.matchId,
              videoId: this.videoId,
              status: 1
            })
            .then(res => {
              if (res.code === "OK") {
                this.$message({
                  message: this.$t("global.投稿成功"),
                  type: "success"
                });
                setTimeout(() => {
                  this.$router.push("/MyCompetition");
                }, 1500);
              }
            });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/match/MatchSupplement.vue